import Http from '../core/Http';

/**
 * [전역 API 오브젝트]
 * 
 * 안녕하세요! 이 오브젝트는 우리 시스템의 모든 HTTP 요청을 담당하는 '관문'입니다.
 * Http.js에서 생성한 공통 Axios 인스턴스를 사용하여 get, post, put, delete 기능을 제공해요.
 * 
 * 왜 이렇게 따로 만들었나요?
 * 1. 서비스 로직에서 Http.js를 직접 불러 쓰는 것보다 관리가 쉬워요.
 * 2. 나중에 파일 업로드나 특수한 공통 처리가 필요할 때 여기서 한 번에 제어할 수 있습니다.
 */
export const api = {
    get: (url, config) => Http.get(url, config),
    post: (url, data, config) => Http.post(url, data, config),
    put: (url, data, config) => Http.put(url, data, config),
    patch: (url, data, config) => Http.patch(url, data, config),
    delete: (url, config) => Http.delete(url, config),
    
// 파일 업로드 전용 메서드입니다.
// FormData를 보낼 때 브라우저가 자동으로 알맞은 경계값(boundary)을 설정할 수 있도록 
// 'Content-Type'을 'multipart/form-data'로 명시해 주었습니다.
    upload: (url, formData, config) => Http.post(url, formData, {
        ...config,
        headers: {
            ...config?.headers,
            'Content-Type': 'multipart/form-data',
        }
    })
};